import cx from 'classnames'
import styles from './card.module.css'

interface Props {
  isHoverable?: boolean
  hasBorder?: boolean
  element?: keyof JSX.IntrinsicElements
  isSearchPage?: boolean
  children?: React.ReactNode
  isBrandNewVehicle?: boolean
}

const Card = ({
  isHoverable,
  hasBorder,
  isSearchPage,
  element = 'div',
  children,
  isBrandNewVehicle = false,
}: Props) => {
  const HtmlElement = element

  return (
    <HtmlElement
      className={cx(styles['card'], {
        [styles['hoverable']]: isHoverable && !isSearchPage,
        [styles['bordered']]: hasBorder && !isSearchPage && !isBrandNewVehicle,
        [styles['noShadowBorder']]: isBrandNewVehicle,
        [styles['cardSearch']]: isSearchPage,
      })}
    >
      {children}
    </HtmlElement>
  )
}

export default Card
